import { waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { KioskController } from '../../canvas/kiosk/KioskController';
import { ActiveObject, Package, PackageHost, resolve, Resolver } from '../../Container';
import { PopupManager } from '../../popups/PopupManager';
import { HostTutorial } from './HostTutorial';
import { ParticipantTutorial } from './ParticipantTutorial';

export class TutorialPackage implements Package {

    public install = (host: PackageHost) => host
        .register(TutorialDriver, 'singleton', 'startable')
        ;
}

class TutorialDriver extends ActiveObject {

    @resolve(Resolver) private resolver!: Resolver;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(PopupManager) private popups!: PopupManager;
    @resolve(KioskController) private ctrl!: KioskController;

    public start() {
        this.run();
    }

    private async run() {

        await waitFor(500);

        const currentUrl = window.location.href;
        const urlString = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
        const tutorial = urlString === 'tutorials-host' ? HostTutorial : ParticipantTutorial;

        const startAt = 0;
        const steps = tutorial.slice(startAt);

        for (const s of steps) {
            await s.run(this.resolver);
        }
    }

}
